import styled from 'styled-components';

export const Button = styled.button<{
  $fullWidth?: boolean;
  background?: string;
  bgHover?: string;
  shadowHover?: string;
}>`
  background: ${({ background }) => background ?? '#049366'};
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  font-family: 'Open Sans', sans-serif;
  font-size: 1.05rem;
  font-weight: 600;
  padding: 1rem 1.8rem;
  transition: all 0.3s ease;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover {
    background: ${({ bgHover }) => bgHover ?? '#037a54'};
    box-shadow: 0 4px 15px
      ${({ shadowHover }) => shadowHover ?? 'rgba(4, 147, 102, 0.3)'};
  }

  &:disabled {
    background: #a0aec0;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;
